/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
export type AdVehicleMenuVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  isResponsive: boolean | null
  fccCurrentAdAlerts: {
    __typename?: 'FccAdAlerts'
    alerts: Array<{
      __typename?: 'FccAdAlert'
      id: string
      type: Types.FccAdAlertType
      status: Types.FccAdAlertStatus
      visibleTo: Array<Types.FccOperatorRoleType>
    }>
  } | null
  fccUpcomingWaypoints: Array<{
    __typename?: 'FccWaypoint'
    adState: Types.FccWaypointState | null
    actions: Array<
      | {
          __typename: 'FccWaypointDeliveryAction'
          id: string
          estimatedAt: string
          pickedUpAt: string | null
          trip: { __typename?: 'Trip'; id: string } | null
          customer: {
            __typename?: 'Customer'
            firstName: string | null
            lastName: string | null
            extendedWalkingTime: boolean
            visualImpairment: boolean | null
          } | null
          ridePassengerInfo: {
            __typename?: 'FccRidePassengerInfo'
            customerId: string | null
            displayName: string | null
            boardingRequirements: {
              __typename?: 'FccBoardingRequirements'
              headCount: number
              childSeat: boolean
              wheelchair: boolean
            } | null
            impairments: {
              __typename?: 'FccImpairments'
              visual: boolean
            } | null
          } | null
        }
      | { __typename: 'FccWaypointHubReturnAction'; id: string }
      | {
          __typename: 'FccWaypointPickupAction'
          id: string
          estimatedAt: string
          pickedUpAt: string | null
          adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
          notShownUpAt: string | null
          tripIsCancelled: boolean | null
          trip: { __typename?: 'Trip'; id: string } | null
          customer: {
            __typename?: 'Customer'
            firstName: string | null
            lastName: string | null
            extendedWalkingTime: boolean
            visualImpairment: boolean | null
          } | null
          ridePassengerInfo: {
            __typename?: 'FccRidePassengerInfo'
            customerId: string | null
            displayName: string | null
            boardingRequirements: {
              __typename?: 'FccBoardingRequirements'
              headCount: number
              childSeat: boolean
              wheelchair: boolean
            } | null
            impairments: {
              __typename?: 'FccImpairments'
              visual: boolean
            } | null
          } | null
        }
      | { __typename: 'FccWaypointReallocationAction' }
    >
    fccStop: {
      __typename?: 'FccStop'
      id: string | null
      names: Partial<Record<'de' | 'en' | 'no', string>>
    } | null
    stopWithServiceArea: {
      __typename?: 'Stop'
      id: string
      serviceArea: { __typename?: 'ServiceArea'; id: string }
    } | null
  }> | null
  fleet: { __typename?: 'Fleet'; id: string } | null
  region: { __typename?: 'Region'; id: string } | null
  vehicleStatusTelemetry?: {
    __typename?: 'VehicleStatusVehicleTelemetry'
    sdsMode: {
      __typename?: 'VehicleStatusSdsModeSignal'
      value: Types.VehicleStatusSdsMode
    } | null
  } | null
  pooling: { __typename?: 'Pooling'; enabled: boolean } | null
}

export const AdVehicleMenuVehicleFragmentDoc = gql`
    fragment AdVehicleMenuVehicle on Vehicle {
  ...AdVehicleStreamServiceCancellationVehicle
  ...AdVehicleStreamHubReturnVehicle
}
    `
